import React from "react";
import ChoiceChips from "../../selection/choiceSelection";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { ChoiceProps } from "models/propTypes/wintFormPropsTypes";

function Choice(props: ChoiceProps) {
  const { value, setValue, items, setTouched } = props;

  const handleChange = (selectedItem: SelectionItem) => {
    setValue(selectedItem.id);
    setTouched(true);
  };

  const selectedItem = items.find((x) => x.id === value);

  return (
    <ChoiceChips
      title={props.label}
      items={props.items}
      value={selectedItem}
      onChange={handleChange}
      disabled={props.disabled}
      isReadOnly={props.readonly}
      disabledItems={props.disabledItems}
      isLoading={props.isLoading}
      hasError={props.showErrorState && props.hasError}
      data-testid={`${props.name}Choice`}
    />
  );
}

export default Choice;
